import '../App.css';
import { useNavigate } from "react-router-dom";
import AdCreative from '../AdCreative';
import UserHeader from '../UserHeader';

function CampaignHeader({ campaign }) {
    const navigate = useNavigate();

    return (
        <div
            className='standard-box2'
            align='left'
            style={{ width: '90%', cursor: 'pointer' }}
            onClick={
                () => {
                    navigate(`/campaign/?campaign_id=${campaign.id}`)
                }
            }
        >
            <div
                style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    alignItems: 'center',
                    padding: '0.5em',
                }}
            >
                <div
                    className='campaign-image'
                    style={{ width: '16em', height: '10em', display: 'flex', alignItems: 'center' }}
                >
                    <AdCreative
                        creativeURL={campaign.creative_url}
                        creativeExt={campaign.creative_ext}
                        width='100%'
                        height='100%'
                        objectFit='contain'
                    />
                </div>
                <div style={{ marginLeft: '1em' }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        {
                            campaign.status == 'active' &&
                            <div className='status-active'>
                                active
                            </div>
                        }
                        {
                            campaign.status != 'active' &&
                            <div className='status-not-active'>
                                active
                            </div>
                        }
                        <h2 style={{ marginLeft: '0.2em' }}>
                            {campaign.title}
                        </h2>
                    </div>
                    <div style={{ marginTop: '1em', display: 'flex', alignItems: 'center' }}>
                        <div style={{ marginRight: '0.5em' }}>
                            Created by:&nbsp;
                        </div>
                        <div>
                            <UserHeader user_id={campaign.owner_id} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CampaignHeader;